import type {ReferralFilters, GenericError} from 'src/types/referral-v2';
import type {Dispatch, ThunkAction} from 'src/reducers';
import {thunkify as flow} from 'src/utils/thunks';
import * as reduxApi from 'src/utils/redux-api';
import {DEFAULT_ERROR} from 'src/action-creators/referral-v2/referral-jobs';


export const REFERRAL_FILTERS_LOADING = 'referral/referral-filters-loading';
export const REFERRAL_FILTERS = 'referral/referral-filters';
export const REFERRAL_FILTERS_ERROR = 'referral/referral-filters-error';

type ReferralFiltersLoadingAction = {
  type: typeof REFERRAL_FILTERS_LOADING;
};

type ReferralFiltersAction = {
  type: typeof REFERRAL_FILTERS;
  payload: ReferralFilters | null | undefined;
  from: string;
  archived: boolean;
};

type ReferralFiltersErrorAction = {
  type: typeof REFERRAL_FILTERS_ERROR;
  payload: GenericError | null | undefined;
};

export type ReferralFiltersActions =
  | ReferralFiltersAction
  | ReferralFiltersErrorAction
  | ReferralFiltersLoadingAction;

const recieveReferralFilters = (
  payload: ReferralFilters,
  from: string,
  archived: boolean,
): ReferralFiltersAction => ({
  type: REFERRAL_FILTERS,
  payload,
  from,
  archived,
});

const getReferralFiltersLoading = (): ReferralFiltersLoadingAction => ({
  type: REFERRAL_FILTERS_LOADING,
});

const getReferralFiltersError = (
  payload?: GenericError | null,
): ReferralFiltersErrorAction => ({
  type: REFERRAL_FILTERS_ERROR,
  payload,
});

export const getReferralFilters: (
  from: string,
  payload: {
    start_date: string;
    end_date: string;
    archived: string;
    search_str: string;
  },
) => ThunkAction<void> = flow()((from, payload) => (dispatch: Dispatch) => {
  // @ts-expect-error - TS2769 - No overload matches this call.
  dispatch(getReferralFiltersLoading());

  return dispatch(reduxApi.get(`referral/${from}/filters`, payload)).then(
    // @ts-expect-error - TS2345 - Argument of type '(response: ReferralFilters) => void' is not assignable to parameter of type '(value: unknown) => void | PromiseLike<void>'.
    (response: ReferralFilters) => {
      // @ts-expect-error - TS2769 - No overload matches this call. | TS2345 - Argument of type 'string' is not assignable to parameter of type 'boolean'.
      dispatch(recieveReferralFilters(response, from, payload.archived));
    },
    (error) => {
      dispatch(
        // @ts-expect-error - TS2769 - No overload matches this call.
        getReferralFiltersError(error?.response?.errors || DEFAULT_ERROR),
      );
    },
  );
});
